import React from 'react';
import {SchemaProps} from "../../../types/Schema";
import {Link} from "react-router-dom";
import Icon from "../../../common/Icon";

type OpenSchemaActionProps = {
  schema?: SchemaProps;
  schemaId?: string;
  standardButton?: boolean;
  disabled?: boolean;
};

/**
 * Generic action for opening a schema in the playground.
 *
 * @param {OpenSchemaActionProps} props
 * @returns {any}
 * @constructor
 */
export default function OpenSchemaAction(props: OpenSchemaActionProps) {
  const schemaId = props.schemaId || props.schema?.id || '';
  if (props.disabled) {
    // Supporting disabling only for standard looking button for now.
    return <span className="btn btn-primary disabled OpenSchemaAction">Open</span>
  }
  const linkTo = `/schema/playground?id=${schemaId}`;
  return props.standardButton ?
    <Link to={linkTo} className="btn btn-primary OpenSchemaAction">
      Open
    </Link> :
    <Link to={linkTo} className="OpenSchemaAction">
      <Icon icon="edit" title="Open schema"/>
    </Link>
}
